import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { baseURL } from '../apiConfig'; // <-- Apni nayi central file se baseURL import kiya
import LiveRateStrip from './LiveRateStrip';

import './SalesVoucher.css';

let savedSalesState = null;

function usePersistentState(key, initialValue) {
  const [state, setState] = useState(() => {
    if (savedSalesState && savedSalesState[key] !== undefined) {
      return savedSalesState[key];
    }
    return typeof initialValue === 'function' ? initialValue() : initialValue;
  });

  useEffect(() => {
    if (!savedSalesState) savedSalesState = {};
    savedSalesState[key] = state;
  }, [state, key]);

  return [state, setState];
}

function SalesVoucher() {
  // const baseURL = process.env.REACT_APP_API_URL || 'http://10.179.18.97:8000';
  // --- DAILY LIVE RATES STATE (WITH LOCAL STORAGE CACHE) ---
  const [rates, setRates] = useState(() => {
    // Check karte hain ki kya Browser ke LocalStorage me purana saved rate hai
    const savedRates = localStorage.getItem('dailyLiveRates');
    if (savedRates) {
      return JSON.parse(savedRates);
    }
    // Agar nahi hai toh ye default initial values rahengi
    return {
      gold24k: 0,
      gold22k: 0,
      gold18k: 0,
      silver100: 0,
      silver925: 0,
      silverCB: 0
    };
  });

  // Rate change hone par state update karna
  const handleRateInputChange = (key, val) => {
    setRates(prev => ({ ...prev, [key]: parseFloat(val) || 0 }));
  };

  // Save / Edit toggle button logic
  const toggleEditRates = () => {
    if (isEditingRates) {
      // Jab user "Save Rates" click karega, tab LocalStorage me permanent save kar do
      localStorage.setItem('dailyLiveRates', JSON.stringify(rates));
      alert("Aaj ke Live Rates local memory me Save ho gaye hain! 👍");
    }
    setIsEditingRates(!isEditingRates);
  };


  // Helper function: Metal aur Purity ke base par sahi rate dhundne ke liye
  const getMatchedRate = (m, p, currentRates) => {
    const metalName = (m || '').toLowerCase().trim();
    const purityVal = (p || '').toLowerCase().trim();

    // 1. GOLD MATCHING LOGIC
    if (metalName.includes('gold') || metalName.includes('sona')) {
      if (purityVal.includes('24')) return currentRates.gold24k;
      if (purityVal.includes('22')) return currentRates.gold22k;
      if (purityVal.includes('18')) return currentRates.gold18k;
      return currentRates.gold22k; // Default fallback for Gold
    }

    // 2. SILVER MATCHING LOGIC
    if (metalName.includes('silver') || metalName.includes('chandi')) {
      if (purityVal.includes('100') || purityVal.includes('pure')) return currentRates.silver100;
      if (purityVal.includes('92.5') || purityVal.includes('925')) return currentRates.silver925;
      if (purityVal.includes('cb')) return currentRates.silverCB;
      return currentRates.silver100; // Default fallback for Silver
    }

    return 0;
  };
  const [billType, setBillType] = usePersistentState("billType", 'Regular'); // State to handle bill type

  // Rates ko Edit / Save mode toggle karne ke liye
  const [isEditingRates, setIsEditingRates] = useState(false);

  // --- 1. SINGLE ITEM INPUT STATES ---
  const [tagId, setTagId] = usePersistentState("tagId", '');
  const [metal, setMetal] = usePersistentState("metal", '');
  const [purity, setPurity] = usePersistentState("purity", '');
  const [itemName, setItemName] = usePersistentState("itemName", '');
  const [itemId, setItemId] = usePersistentState("itemId", '');
  const [remarks, setRemarks] = usePersistentState("remarks", '');
  const [weight, setWeight] = usePersistentState("weight", 0);
  const [ratePerGram, setRatePerGram] = usePersistentState("ratePerGram", 0);
  const [rawMaking, setRawMaking] = usePersistentState("rawMaking", 0);
  const [makingCharges, setMakingCharges] = usePersistentState("makingCharges", 0);
  const [makingType, setMakingType] = usePersistentState("makingType", 'Fixed');
  const [discount, setDiscount] = usePersistentState("discount", 0);
  const [itemImage, setItemImage] = usePersistentState("itemImage", '');
  
  // Calculated single item fields
  const [itemTotal, setItemTotal] = usePersistentState("itemTotal", 0);
  const [cgst, setCgst] = usePersistentState("cgst", 0);
  const [sgst, setSgst] = usePersistentState("sgst", 0);
  const [grandTotal, setGrandTotal] = usePersistentState("grandTotal", 0);

  // --- 2. DYNAMIC GRID/TABLE STATE ---
  const [itemsList, setItemsList] = usePersistentState("itemsList", []);

  // --- 3. CUSTOMER & PAYMENT STATES ---
  const [invoiceNumber, setInvoiceNumber] = usePersistentState("invoiceNumber", ''); 
  const [customerName, setCustomerName] = usePersistentState("customerName", '');
  const [mobile, setMobile] = usePersistentState("mobile", '');
  const [address, setAddress] = usePersistentState("address", '');
  const [email, setEmail] = usePersistentState("email", '');
  const [selectedCustomerId, setSelectedCustomerId] = usePersistentState("selectedCustomerId", ''); 
  
  const [billDate, setBillDate] = usePersistentState("billDate", () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  }); 
  const [paymentMode, setPaymentMode] = usePersistentState("paymentMode", 'Cash');
  const [billSettlementAmt, setBillSettlementAmt] = usePersistentState("billSettlementAmt", 0);
  const [customersList, setCustomersList] = usePersistentState("customersList", []); 

  const [cashAmount, setCashAmount] = usePersistentState("cashAmount", 0);
  const [creditAmount, setCreditAmount] = usePersistentState("creditAmount", 0);

  // --- FETCH NEXT INVOICE NUMBER FROM DJANGO ---
  // const fetchNextInvoiceNumber = async () => {
  //   try {
  //     // const response = await fetch('http://127.0.0.1:8000/api/get_next_invoice_no/');
  //     const response = await fetch(`${baseURL}/api/get_next_invoice_no/`);
      
  //     // niche wala 1 line new hai
  //     // const response = await fetch("http://127.0.0.1:8000/api/get_stock_by_tag/?tag=" + scannedTag);
  //     const data = await response.json();
  //     if (data.success) {
  //       setInvoiceNumber(data.next_invoice_no);
  //     } else {
  //       console.error("Backend unable to send next invoice index:", data.message);
  //     }
  //   } catch (error) {
  //     console.error("Network error while fetching invoice number:", error);
  //   }
  // };

  // --- FETCH NEXT INVOICE NUMBER FROM DJANGO BASED ON BILL TYPE ---
  const fetchNextInvoiceNumber = async (selectedType = billType) => {
    try {
      const response = await fetch(`${baseURL}/api/get_next_invoice_no/?type=${selectedType}`);
      const data = await response.json();
      if (data.success) {
        setInvoiceNumber(data.next_invoice_no);
      } else {
        console.error("Backend unable to send next invoice index:", data.message);
      }
    } catch (error) {
      console.error("Network error while fetching invoice number:", error);
    }
  };

  // --- FETCH ALL CUSTOMERS FROM DJANGO ---
  const fetchCustomers = async () => {
    try {
      // const response = await fetch('http://127.0.0.1:8000/api/get_customers/'); 
      const response = await fetch(`${baseURL}/api/get_customers/`); 
      
      const data = await response.json();
      console.log("Django se aaya raw data:", data); 
      if (data && data.success && Array.isArray(data.customers)) {
        setCustomersList(data.customers);
      } else {
        setCustomersList([]);
      }
    } catch (error) {
      console.error("Customers data load karne me dikkat aayi:", error);
      setCustomersList([]);
    }
  };

  // useEffect(() => {
  //   fetchNextInvoiceNumber();
  //   fetchCustomers();
  // }, []);

  const prevBillTypeRef = useRef(billType);
  useEffect(() => {
    if (!invoiceNumber || prevBillTypeRef.current !== billType) {
      prevBillTypeRef.current = billType;
      fetchNextInvoiceNumber(billType);
    }
  }, [billType]);

  useEffect(() => {
    if (!customersList || customersList.length === 0) {
      fetchCustomers();
    }
  }, []);
  
  // Customer Dropdown selection handler
  const handleCustomerSelect = (selectedId) => {
    setSelectedCustomerId(selectedId); 
    if (!selectedId) {
      setCustomerName(''); setMobile(''); setAddress(''); setEmail('');
      return;
    }

    const customer = customersList.find(c => c && c.id && c.id.toString() === selectedId.toString());
    if (customer) {
      setCustomerName(customer.name || '');
      setMobile(customer.mobile || '');
      setAddress(customer.address || '');
      setEmail(customer.email || '');
    }
  };    
  
  // // --- AUTOMATIC CALCULATION LOGIC ---
  // useEffect(() => {
  //   let makingValue = 0;
  //   const w = parseFloat(weight) || 0;
  //   const r = parseFloat(ratePerGram) || 0;
  //   const m = parseFloat(makingCharges) || 0;

  //   // 🟢 Making Type Condition Logic
  //   if (makingType === "Fixed" || makingType === "F") {
  //     makingValue = m;
  //   } else if (makingType === "Percent" || makingType === "P") {
  //     makingValue = (r * w) * (m / 100);
  //   } else if (makingType === "Per Gram" || makingType === "G") {
  //     makingValue = w * m;
  //   }

  //   const basicTotal = (w * r) + makingValue - (parseFloat(discount) || 0);
  //   setItemTotal(basicTotal > 0 ? basicTotal : 0);

  //   let calculatedCgst = 0;
  //   let calculatedSgst = 0;

  //   if (billType === 'Regular') {
  //     calculatedCgst = basicTotal * 0.015;
  //     calculatedSgst = basicTotal * 0.015;
  //   }

  //   setCgst(calculatedCgst > 0 ? calculatedCgst : 0);
  //   setSgst(calculatedSgst > 0 ? calculatedSgst : 0);

  //   const finalGrand = basicTotal + calculatedCgst + calculatedSgst;
  //   setGrandTotal(finalGrand > 0 ? Math.round(finalGrand) : 0);
    
  //   // 👈 Dependency array mein makingType zarur add karein
  // }, [weight, ratePerGram, makingCharges, makingType, discount, billType]);

  // --- AUTOMATIC CALCULATION LOGIC ---
  useEffect(() => {
    let makingValue = 0;
    const w = parseFloat(weight) || 0;
    const r = parseFloat(ratePerGram) || 0;
    
    // 🔥 Yahan 'makingCharges' ki jagah 'rawMaking' ka use karenge calculation ke liye
    const rm = parseFloat(rawMaking) || 0; 

    // 🟢 Making Type Condition Logic (Database support ke sath)
    if (makingType === "Fixed" || makingType === "F") {
      makingValue = rm;
    } else if (makingType === "Percent" || makingType === "P" || makingType === "Pcnt") {
      makingValue = (r * w) * (rm / 100);
    } else if (makingType === "Per Gram" || makingType === "G" || makingType === "/G") {
      makingValue = w * rm;
    }

    // 🔥 Calculated result ko read-only box (makingCharges) mein set kar rahe hain
    setMakingCharges(Math.round(makingValue));

    const basicTotal = (w * r) + makingValue - (parseFloat(discount) || 0);
    setItemTotal(basicTotal > 0 ? basicTotal : 0);

    let calculatedCgst = 0;
    let calculatedSgst = 0;

    if (billType === 'Regular') {
      calculatedCgst = basicTotal * 0.015;
      calculatedSgst = basicTotal * 0.015;
    }

    setCgst(calculatedCgst > 0 ? calculatedCgst : 0);
    setSgst(calculatedSgst > 0 ? calculatedSgst : 0);

    const finalGrand = basicTotal + calculatedCgst + calculatedSgst;
    setGrandTotal(finalGrand > 0 ? Math.round(finalGrand) : 0);
    
    // 👈 Dependency array mein rawMaking aur makingType zarur hone chahiye
  }, [weight, ratePerGram, rawMaking, makingType, discount, billType]);

  // --- 🛠️ SPLIT PAYMENT HANDLERS ---
  const handleCashAmountChange = (val) => {
    const cash = parseFloat(val) || 0;
    setCashAmount(cash);
    
    const totalSettle = parseFloat(billSettlementAmt) || 0;
    const remainingCredit = totalSettle - cash;
    setCreditAmount(remainingCredit > 0 ? remainingCredit : 0);
  };

  const handleCreditAmountChange = (val) => {
    const credit = parseFloat(val) || 0;
    setCreditAmount(credit);
    
    const totalSettle = parseFloat(billSettlementAmt) || 0;
    const remainingCash = totalSettle - credit;
    setCashAmount(remainingCash > 0 ? remainingCash : 0);
  };

  // --- GRID ACTIONS (ADD / REMOVE ITEM) ---
  const handleAddItem = () => {
    if (!itemName || !weight || !ratePerGram) {
      alert("Please enter Item Name, Weight, and Rate/Gram minimum!");
      return;
    }

        if (tagId && tagId.trim() !== "") {
      const isDuplicate = itemsList.some(item => item.tagId && item.tagId.toString().toLowerCase() === tagId.toString().toLowerCase());
      if (isDuplicate) {
        alert("Ye item pehle se hi list me add kiya ja chuka hai!");
        return;
      }
    }
    const newItem = {
      id: Date.now(),
      tagId, metal, purity, itemName, itemId, remarks,
      image: itemImage || '', // <--- Add item image if available from stock fetch
      weight: parseFloat(weight) || 0,
      ratePerGram: parseFloat(ratePerGram) || 0,
      makingCharges: parseFloat(makingCharges) || 0,
      discount: parseFloat(discount) || 0,
      itemTotal: parseFloat(itemTotal) || 0,
      cgst: parseFloat(cgst) || 0, // table display ke crash ko safe kiya
      sgst: parseFloat(sgst) || 0,
      grandTotal: parseFloat(grandTotal) || 0,
      category: 'Gold',
      billDate
    };

    setItemsList([...itemsList, newItem]);

    setTagId(''); setMetal(''); setPurity(''); setItemName(''); setItemId(''); setRemarks('');
    setWeight(0); setRatePerGram(0); setRawMaking(0); setMakingCharges(0); setDiscount(0); setItemImage('');
    setItemTotal(0); setCgst(0); setSgst(0); setGrandTotal(0);
  };

  const handleRemoveItem = (id) => {
    setItemsList(itemsList.filter(item => item.id !== id));
  };

  const overallBillTotal = itemsList.reduce((sum, item) => sum + (parseFloat(item.grandTotal) || 0), 0);

  // 🔥 Bill Grand Total calculate hote hi Settlement Amt me automatically dalna (runtime me user change kar sakta hai)
  const isFirstMountRef = useRef(true);
  useEffect(() => {
    if (isFirstMountRef.current) {
      isFirstMountRef.current = false;
      if (!billSettlementAmt && overallBillTotal > 0) {
        setBillSettlementAmt(overallBillTotal);
      }
      return;
    }
    setBillSettlementAmt(overallBillTotal);
    if (paymentMode === 'Cash & Credit') {
      const remainingCredit = overallBillTotal - (parseFloat(cashAmount) || 0);
      setCreditAmount(remainingCredit > 0 ? remainingCredit : 0);
    }
  }, [overallBillTotal]);

  // --- LIVE SAVE OPERATION ---
  const handleMakeBill = async (e) => {
    e.preventDefault();

    if (itemsList.length === 0) {
        alert("Billing grid khali hai! Kam se kam ek item zaroor jodein.");
        return;
    }

    const finalInvoiceData = {
      billType, // 👈 Send bill type to backend
      invoiceNumber,
      customerName,
      mobile,
      address,              
      customerAddress: address, 
      email,
      billDate,
      paymentMode,
      overallBillTotal,
      billSettlementAmt: parseFloat(billSettlementAmt) || 0, 
      cashAmount: parseFloat(cashAmount) || 0,
      creditAmount: parseFloat(creditAmount) || 0,
      selectedCustomerId: selectedCustomerId, // Taaki Django ko pata chale kis customer ka khata update karna hai
      soldBy: localStorage.getItem('username') || localStorage.getItem('user_name') || 'Admin', // <--- DYNAMIC USERNAME
      items: itemsList
    };

    // 🔥 BAS YEH EK LINE ADD KAREIN
    console.log("🚀 Payload Check:", finalInvoiceData);
    
    try {
        // const response = await fetch('http://127.0.0.1:8000/store/save_invoice_mysql/', {
        const response = await fetch(`${baseURL}/store/save_invoice_mysql/`, {          
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(finalInvoiceData)
        });

        // if (response.ok) {
        //     const blob = await response.blob();
        //     const pdfUrl = URL.createObjectURL(blob);
            
        //     window.open(pdfUrl, '_blank');            
        //     // alert("Solid Bhai! Data bhee save ho gya aur PDF Invoice bhee generate ho gya.");
            
        //     handleReset(); 
        //     fetchNextInvoiceNumber(); 
        // } 
        
        if (response.ok) {
            const blob = await response.blob();
            const pdfUrl = URL.createObjectURL(blob);

            // Check karega ki billType Estimated hai ya Regular
            const prefix = billType === 'Estimated' ? 'E' : 'R';
            const fileName = `${prefix}_Invoice_${invoiceNumber}.pdf`;
            
            // --- NAYA AUTO-DOWNLOAD LOGIC ---
            const link = document.createElement('a');
            link.href = pdfUrl;
            // Invoice number ke sath file ka naam set hoga
            link.setAttribute('download', fileName); 
            document.body.appendChild(link);
            link.click();
            
            // Download trigger hone ke baad memory saaf karna
            link.parentNode.removeChild(link);
            window.open(pdfUrl, '_blank');
            
            // 3. Memory clean up (Naye tab ko load hone ka thoda time dene ke liye setTimeout use kiya)
            setTimeout(() => {
                window.URL.revokeObjectURL(pdfUrl);
            }, 2000);
            
            handleReset(); 
            // Reset hone ke baad agla invoice number bhi usi type ka fetch karo
            fetchNextInvoiceNumber(billType); 
        }
        else {
            const errorText = await response.text();
            alert("Billing me dikkat aayi: " + errorText);
        }
    } catch (error) {
        console.error("Network Error:", error);
        alert("Django backend server se connection fail ho gya!");
    }
  };

  const handleReset = () => {
    savedSalesState = null;
    setItemsList([]);
    setCustomerName(''); 
    setMobile(''); 
    setAddress(''); 
    setEmail('');
    setSelectedCustomerId('');
    setBillSettlementAmt(0);
    setCashAmount(0);
    setCreditAmount(0);
    setTagId('');
    setMetal('');
    setPurity('');
    setItemName('');
    setItemId('');
    setRemarks('');
    setWeight(0);
    setRatePerGram(0);
    setRawMaking(0);
    setMakingCharges(0);
    setDiscount(0);
    setItemImage('');
    setItemTotal(0);
    setCgst(0);
    setSgst(0);
    setGrandTotal(0);
    fetchNextInvoiceNumber(billType);
  };

  // SalesVoucher.js ke andar handleTagFetch ko aise update karein:

  // const handleTagFetch = async (scannedTag) => {
  //   if (!scannedTag || scannedTag.trim() === "") return;

  //   try {
  //     // const response = await fetch("http://127.0.0.1:8000/api/get_stock_by_tag/?tag=" + scannedTag);
  //     const response = await fetch(`${baseURL}/api/get_stock_by_tag/?tag=` + scannedTag);
           
  //     const resData = await response.json();

  //     if (response.ok && resData.status === 'success') {
  //       // ✅ Condition Pass: Item Available hai, toh details autofill karo
  //       setItemName(resData.itemName || '');
  //       setItemId(resData.tagText || '');     
  //       setRemarks(resData.remarks || '');    
  //       setMetal(resData.metal || '');
  //       setPurity(resData.purity || '');
  //       setWeight(resData.weight || 0);
  //       setMakingCharges(resData.making || 0);
  //       setMakingType(resData.makingType || 'Fixed');
  //       // setItemImage(resData.image || resData.imageUrl || '');
  //       setItemImage(resData.image ? `${baseURL}/media/${resData.image}` : '');
  //       // ... purana tag fetch ka details
  //       setMetal(resData.metal || '');
  //       setPurity(resData.purity || '');
  //       setWeight(resData.weight || 0);
  //       setMakingCharges(resData.making || 0);

  //       // 🔥 NAYA ADDITION: Auto-fill rate from Top Bar
  //       const autoRate = getMatchedRate(resData.metal, resData.purity, rates);
  //       if (autoRate > 0) {
  //         setRatePerGram(autoRate);
  //       }
        
  //     } else {
  //       alert(resData.message || "Invalid Tag ID");
  //       // Fields ko clear kar dete hain taaki galat entry forward na ho
  //       setTagId('');
  //       setItemName('');
  //       setItemId('');
  //       setRemarks('');
  //       setMetal('');
  //       setPurity('');
  //       setWeight(0);
  //       setMakingCharges(0);
  //       setItemImage('');
  //     }
  //   } catch (error) {
  //     console.error("Error fetching tag:", error);
  //     alert("Backend server se contact nahi ho paya!");
  //   }
  // };

  const handleTagFetch = async (scannedTag) => {
    if (!scannedTag || scannedTag.trim() === "") return;

    try {
      const response = await fetch(`${baseURL}/api/get_stock_by_tag/?tag=` + scannedTag);
      const resData = await response.json();

      if (response.ok && resData.status === 'success') {
        // ✅ Condition Pass: Item Available hai, toh details autofill karo
        setItemName(resData.itemName || '');
        setItemId(resData.tagText || '');     
        setRemarks(resData.remarks || '');    
        setMetal(resData.metal || '');
        setPurity(resData.purity || '');
        setItemImage(resData.image ? (resData.image.startsWith('http') ? resData.image : `${baseURL}/media/${resData.image}`) : '');

        // Weight aur Rate ko pehle setup karein
        const itemWeight = parseFloat(resData.weight) || 0;
        setWeight(itemWeight);

        // 🔥 Auto-fill rate from Top Bar
      //   const autoRate = getMatchedRate(resData.metal, resData.purity, rates) || 0;
      //   if (autoRate > 0) {
      //     setRatePerGram(autoRate);
      //   }

      //   // 🔥 NAYA ADDITION: Making Charge ko sidha Rupees (₹) me calculate karein
      //   const dbMaking = parseFloat(resData.making) || 0;
      //   const dbMakingType = resData.makingType || 'Fixed';
      //   let finalMakingAmt = dbMaking;

      //   // Agar percentage ya per gram hai, toh actual ₹ value nikalein
      //   // if (dbMakingType === 'Percent' || dbMakingType === 'P') {
      //   //   finalMakingAmt = (autoRate * itemWeight) * (dbMaking / 100);
      //   // } else if (dbMakingType === 'Per Gram' || dbMakingType === 'G') {
      //   //   finalMakingAmt = itemWeight * dbMaking;
      //   // }
      //   // 🔥 FIX: Database se aane wale 'Pcnt' aur '/G' ko properly handle karein
        
      //   if (dbMakingType === 'Percent' || dbMakingType === 'P' || dbMakingType === 'Pcnt') {
      //     finalMakingAmt = (autoRate * itemWeight) * (dbMaking / 100);
      //   } else if (dbMakingType === 'Per Gram' || dbMakingType === 'G' || dbMakingType === '/G') {
      //     finalMakingAmt = itemWeight * dbMaking;
      //   }

      //   // Textbox me final ₹ amount bharein aur dropdown ko default 'Fixed' par lock karein
      //   setMakingCharges(Math.round(finalMakingAmt));
      //   setMakingType('Fixed');

      // } else {
      //   alert(resData.message || "Invalid Tag ID");
      //   // Fields ko clear kar dete hain taaki galat entry forward na ho
      //   setTagId('');
      //   setItemName('');
      //   setItemId('');
      //   setRemarks('');
      //   setMetal('');
      //   setPurity('');
      //   setWeight(0);
      //   setMakingCharges(0);
      //   setMakingType('Fixed'); // Ise bhi clear karein
      //   setItemImage('');
      // }
  //   } catch (error) {
  //     console.error("Error fetching tag:", error);
  //     alert("Backend server se contact nahi ho paya!");
  //   }
  // };

  // 🔥 Auto-fill rate from Top Bar
        const autoRate = getMatchedRate(resData.metal, resData.purity, rates) || 0;
        if (autoRate > 0) {
          setRatePerGram(autoRate);
        }

        // 🔥 NAYA ADDITION: Database ki exact values textbox aur dropdown ko de dein
        const dbMaking = parseFloat(resData.making) || 0;
        const dbMakingType = resData.makingType || 'Fixed';

        setRawMaking(dbMaking);
        setMakingType(dbMakingType);

      } else {
        alert(resData.message || "Invalid Tag ID");
        // Fields ko clear kar dete hain taaki galat entry forward na ho
        setTagId('');
        setItemName('');
        setItemId('');
        setRemarks('');
        setMetal('');
        setPurity('');
        setWeight(0);
        setRawMaking(0); // Ise bhi reset karna zaroori hai
        setMakingCharges(0);
        setMakingType('Fixed');
        setItemImage('');
      }
      } catch (error) {
      console.error("Error fetching tag:", error);
      alert("Backend server se contact nahi ho paya!");
    }
  };

  const formatDecimal = (val) => {
    const num = parseFloat(val);
    return isNaN(num) ? "0.00" : num.toFixed(2);
  };

  // --- BILL TYPE CHANGE HANDLER (Grid update ke sath) ---
  const handleBillTypeChange = (e) => {
    const newType = e.target.value;
    setBillType(newType);
    fetchNextInvoiceNumber(newType); // Naya invoice number fetch karega

    // Agar table me pehle se items add hain, toh unka GST recalculate karega
    if (itemsList.length > 0) {
      const updatedItemsList = itemsList.map(item => {
        let updatedCgst = 0;
        let updatedSgst = 0;

        // Sirf Regular bill par GST jodein
        if (newType === 'Regular') {
          updatedCgst = item.itemTotal * 0.015;
          updatedSgst = item.itemTotal * 0.015;
        }

        const updatedGrand = item.itemTotal + updatedCgst + updatedSgst;

        return {
          ...item,
          cgst: updatedCgst > 0 ? updatedCgst : 0,
          sgst: updatedSgst > 0 ? updatedSgst : 0,
          grandTotal: updatedGrand > 0 ? Math.round(updatedGrand) : 0
        };
      });
      setItemsList(updatedItemsList);
    }
  };




  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlTagId = params.get('tagId');
    if (urlTagId) {
      setTagId(urlTagId);
      handleTagFetch(urlTagId);
      // clear the query param safely without reloading
      window.history.replaceState({}, '', '/sales');
    }
  }, [location, rates]);

  return (
    <div className="sales-voucher-container">

      {/* ================= ?? TOP LIVE RATE BAR ================= */}
      <LiveRateStrip onRatesUpdate={setRates} />

      <div className="voucher-titlebar">Sales Voucher</div>
      
      {/* ================= TOP SECTION: ITEMS DETAILS ================= */}
      <div className="voucher-section">
        <span className="section-label">Items Details</span>
        <div className="form-grid-top">
          
          <div className="input-box tag-search-box">
            <label>Tag ID</label>
            <div className="tag-input-wrapper">
              <input 
                type="text" 
                placeholder="scan or type" 
                value={tagId} 
                onChange={(e) => setTagId(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleTagFetch(tagId); 
                  }
                }}
                /* 🔥 Mobile FIX: Jab 'Next' dabakar cursor bahar jayega, tab bhi fetch ho jayega */
                onBlur={() => {
                  if(tagId.trim() !== "") {
                    handleTagFetch(tagId);
                  }
                }}
              />
              {/* 🔥 Mobile FIX 2: Ek chota visual search button */}
              <button 
                type="button" 
                className="btn-tag-search" 
                onClick={() => handleTagFetch(tagId)}
              >
                🔍
              </button>
            </div>
          </div>
          
          <div className="input-box"><label>Metal</label><input type="text" value={metal} onChange={(e) => setMetal(e.target.value)} placeholder="e.g. Gold" /></div>
          <div className="input-box"><label>Purity</label><input type="text" value={purity} onChange={(e) => setPurity(e.target.value)} placeholder="e.g. 22K" /></div>
          <div className="input-box"><label>Item Name</label><input type="text" value={itemName} onChange={(e) => setItemName(e.target.value)} /></div>
          <div className="input-box">
            <label>Item ID</label>
            <input 
              type="text" 
              value={itemId || ''} 
              onChange={(e) => setItemId(e.target.value)} 
            />
          </div>
          <div className="input-box"><label>Remarks</label><input type="text" value={remarks} onChange={(e) => setRemarks(e.target.value)} /></div>
        </div>

        
        
        
        
      
      {/* ========================================================
            FINAL LOGICAL LAYOUT: 2-ROW DESIGN TO PREVENT OVERFLOW
            ======================================================== */}
        <div style={{ backgroundColor: '#1e1e1e', padding: '15px', borderRadius: '6px', border: '1px dashed #555', marginTop: '20px' }}>
          
          {/* ROW 1: USER INPUTS */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', marginBottom: '15px' }}>
            <div className="input-box" style={{ flex: '1', minWidth: '90px' }}>
              <label>Weight (g)</label>
              <input type="number" value={weight} onChange={(e) => setWeight(e.target.value)} />
            </div>
            
            <div className="input-box" style={{ flex: '1', minWidth: '90px' }}>
              <label>Rate</label>
              <input type="number" value={ratePerGram} onChange={(e) => setRatePerGram(e.target.value)} />
            </div>
            
            <div className="input-box" style={{ flex: '3', minWidth: '260px' }}>
              <label>Making (Val + Type = ₹)</label>
              <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                <input type="number" value={rawMaking} onChange={(e) => setRawMaking(e.target.value)} style={{ flex: '1', padding: '8px 10px' }} />
                <select value={makingType} onChange={(e) => setMakingType(e.target.value)} style={{ flex: '1.2', padding: '8px', backgroundColor: '#222', color: 'white', border: '1px solid #555', borderRadius: '4px' }}>
                  <option value="Fixed">₹ Fix</option>
                  <option value="Pcnt">% Pcnt</option>
                  <option value="/G">/g</option>
                </select>
                <span style={{color: '#bfa15f', fontWeight: 'bold'}}>=</span>
                <input type="number" value={makingCharges} readOnly style={{ flex: '1.2', padding: '8px 10px', color: '#bfa15f', fontWeight: 'bold', backgroundColor: '#111', cursor: 'not-allowed', border: '1px dashed #555' }} />
              </div>
            </div>

            <div className="input-box" style={{ flex: '1', minWidth: '90px' }}>
              <label>Discount</label>
              <input type="number" value={discount} onChange={(e) => setDiscount(e.target.value)} />
            </div>
          </div>

          {/* ROW 2: CALCULATED TOTALS & BUTTON */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', alignItems: 'flex-end', borderTop: '1px solid #333', paddingTop: '15px' }}>
            <div className="input-box readonly" style={{ flex: '1.5', minWidth: '100px' }}>
              <label>Total</label>
              <input type="text" value={formatDecimal(itemTotal)} readOnly />
            </div>
            
            <div className="input-box readonly" style={{ flex: '1', minWidth: '80px' }}>
              <label>CGST</label>
              <input type="text" value={formatDecimal(cgst)} readOnly />
            </div>
            
            <div className="input-box readonly" style={{ flex: '1', minWidth: '80px' }}>
              <label>SGST</label>
              <input type="text" value={formatDecimal(sgst)} readOnly />
            </div>
            
            <div className="input-box readonly highlight" style={{ flex: '1.5', minWidth: '120px' }}>
              <label>Grand Total</label>
              <input type="text" value={formatDecimal(grandTotal)} readOnly />
            </div>
            
            <div style={{ flex: '1', minWidth: '100px' }}>
              <button type="button" className="btn-add" onClick={handleAddItem} style={{ width: '100%', padding: '10px 0', margin: '0' }}>Add Item</button>
            </div>
          </div>

        </div>





      </div>

      {/* ================= MIDDLE SECTION: DATA GRID ================= */}
      <div className="voucher-section table-wrapper">
        <table className="items-table">
          <thead>
            <tr>
              <th>Action</th>
              <th>Tag ID</th>
              <th>Metal</th>
              <th>Purity</th>
              <th>Item Name</th>
              <th>Weight</th>
              <th>Rate</th>
              <th>Making</th>
              <th>Discount</th>
              <th>CGST</th>
              <th>SGST</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {itemsList.length === 0 ? (
              <tr>
                <td colSpan="12" style={{textAlign: 'center', color: '#888', padding: '20px'}}>No items added to the voucher yet.</td>
              </tr>
            ) : (
              itemsList.map((item) => (
                <tr key={item.id}>
                  <td><button type="button" className="btn-remove" onClick={() => handleRemoveItem(item.id)}>Remove</button></td>
                  <td>{item.tagId}</td>
                  <td>{item.metal}</td>
                  <td>{item.purity}</td>
                  <td>{item.itemName}</td>
                  <td>{item.weight}g</td>
                  <td>₹{item.ratePerGram}</td>
                  <td>₹{item.makingCharges}</td>
                  <td>₹{item.discount}</td>
                  <td>₹{formatDecimal(item.cgst)}</td>
                  <td>₹{formatDecimal(item.sgst)}</td>
                  <td style={{fontWeight: 'bold', color: '#bfa15f'}}>₹{formatDecimal(item.grandTotal)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* ================= BOTTOM SECTION: CUSTOMER & PAYMENT INFO ================= */}
      <form onSubmit={handleMakeBill}>
        <div className="voucher-section">
          <span className="section-label">Customer Information</span>
          
          <div className="form-row-custom">

            {/* <div className="input-box">
              <label>Bill Type</label>
              <select 
                value={billType} 
                onChange={(e) => setBillType(e.target.value)}
                style={{ border: '1px solid #bfa15f', background: '#222', color: '#fff', fontWeight: 'bold' }}
              >
                <option value="Regular">Regular</option>
                <option value="Estimated">Estimated</option>
              </select>
            </div> */}            

            <div className="input-box">
              <label>Bill Type</label>
              <select 
                value={billType} 
                // onChange={(e) => {
                  onChange={handleBillTypeChange}
                //   const newType = e.target.value;
                //   setBillType(newType);
                //   fetchNextInvoiceNumber(newType); // Immediate invoice sync
                // }}
                style={{ border: '1px solid #bfa15f', background: '#222', color: '#fff', fontWeight: 'bold' }}
              >
                <option value="Regular">Regular</option>
                <option value="Estimated">Estimated</option>
              </select>
            </div>
            <div className="input-box">
              <label>Invoice Number</label>
              <input type="text" value={invoiceNumber} readOnly style={{ backgroundColor: '#222', color: '#bfa15f', fontWeight: 'bold' }} />
            </div>
            <div className="input-box">
              <label>Payment Mode</label>
              <select 
                value={paymentMode} 
                onChange={(e) => {
                  const newMode = e.target.value;
                  setPaymentMode(newMode);
                  setCustomerName(''); 
                  setMobile(''); 
                  setAddress(''); 
                  setEmail('');
                  setSelectedCustomerId('');
                  if (newMode === 'Cash & Credit') {
                    const currentSettle = parseFloat(billSettlementAmt) || overallBillTotal || 0;
                    setCashAmount(0);
                    setCreditAmount(currentSettle);
                  }
                }}
              >
                <option value="Cash">Cash</option>
                {/* <option value="Bank Transfer">Bank Transfer</option> */}
                <option value="UPI">UPI</option>
                <option value="Card">Card</option>
                <option value="Credit">Credit</option>
                <option value="Cash & Credit">Cash & Credit</option>
              </select>
            </div>

            <div className="input-box">
              <label>Date</label>
              <input type="date" value={billDate} onChange={(e) => setBillDate(e.target.value)} />
            </div>
          </div>

          <div className="form-row-custom">
            <div className="input-box">
              <label>Customer Name</label>
              {paymentMode === 'Credit' || paymentMode === 'Cash & Credit' ? (
                <select 
                  value={selectedCustomerId} 
                  onChange={(e) => handleCustomerSelect(e.target.value)} 
                  style={{ border: '1px solid #bfa15f', background: '#333', color: '#fff' }}
                >
                  <option value="">-- Select Saved Customer --</option>
                  {customersList && customersList.map((cust) => (
                    <option key={cust.id} value={cust.id}>
                      {cust.name}
                    </option>
                  ))}
                </select>
              ) : (
                <input type="text" value={customerName} onChange={(e) => setCustomerName(e.target.value)} />
              )}
            </div>

            <div className="input-box">
              <label>Mobile</label>
              <input 
                type="text" 
                value={mobile} 
                readOnly={paymentMode === 'Credit' || paymentMode === 'Cash & Credit'} 
                onChange={(e) => setMobile(e.target.value)} 
              />
            </div>
            
            <div className="input-box wide">
              <label>Address</label>
              <input 
                type="text" 
                name="address" 
                value={address} 
                readOnly={paymentMode === 'Credit' || paymentMode === 'Cash & Credit'} 
                onChange={(e) => setAddress(e.target.value)} 
              />
            </div>
            
            <div className="input-box">
              <label>E-mail</label>
              <input 
                type="text" 
                value={email} 
                readOnly={paymentMode === 'Credit' || paymentMode === 'Cash & Credit'} 
                onChange={(e) => setEmail(e.target.value)} 
              />
            </div>
          </div>
        </div>

        {/* FIXED FOOTER PANE LAYOUT */}
        <div className="footer-pane">
          
          {/* Left Block: Split inputs (Cash & Credit ke liye) */}
          <div className="payment-info">
            {paymentMode === 'Cash & Credit' && (
              <div className="split-payment-container">
                <div className="input-box">
                  <label>CASH AMT</label>
                  <input 
                    type="number" 
                    value={cashAmount} 
                    onChange={(e) => handleCashAmountChange(e.target.value)} 
                  />
                </div>
                <div className="input-box">
                  <label>CREDIT AMT</label>
                  <input 
                    type="number" 
                    value={creditAmount} 
                    onChange={(e) => handleCreditAmountChange(e.target.value)} 
                  />
                </div>
              </div>
            )}
          </div>

          {/* Center/Right Block: Totals & Settlement */}
          <div className="billing-totals">
            <div className="total-row-item">
              <span className="total-label">Bill Grand Total:</span>
              <span className="total-val-green">₹{Number(overallBillTotal).toLocaleString('en-IN')}</span> 
            </div>
            
            <div className="total-row-item">
              <span className="total-label">Settlement Amt:</span>
              <input 
                type="text" 
                className="settle-input-box"
                value={billSettlementAmt ? Number(String(billSettlementAmt).replace(/,/g, '')).toLocaleString('en-IN') : ''} 
                onChange={(e) => {
                  const rawVal = e.target.value.replace(/,/g, '');
                  if (!isNaN(rawVal)) {
                    setBillSettlementAmt(rawVal);
                    if (paymentMode === 'Cash & Credit') {
                      const newSettle = parseFloat(rawVal) || 0;
                      const remainingCredit = newSettle - cashAmount;
                      setCreditAmount(remainingCredit > 0 ? remainingCredit : 0);
                    }
                  }
                }} 
              />
            </div>
          </div>
          
          {/* Right Block: Buttons side-by-side */}
          <div className="final-actions">
            <button type="submit" className="btn-makebill">Make Bill</button>
            <button type="button" className="btn-reset" onClick={handleReset}>Reset</button>
          </div>

        </div>
      </form>
    </div>
  );
}

export default SalesVoucher;
